import script from "./AboutTab2.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutTab2.vue?vue&type=script&setup=true&lang=js"

import "./AboutTab2.vue?vue&type=style&index=0&id=f31964fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f31964fa"]])

export default __exports__